import { MouseEventHandler, useCallback } from "react";

import { Box, ButtonGroup, IconButton, Tab, Text } from "@chakra-ui/react";

import { CloseIcon } from "@/components/shared/ReleaseIcons";
import { TerminalConnection, useTerminals } from "@/providers/useTerminals";

interface Props {
  terminal: TerminalConnection;
}

function TerminalTab({ terminal }: Props) {
  const { setTerminalTabIndex, panelTerminals, closeTerminal } = useTerminals();
  const panelIndex = panelTerminals.indexOf(terminal);

  const handleCloseTab: MouseEventHandler<HTMLButtonElement> = useCallback(
    e => {
      closeTerminal(terminal.terminalId);
    },
    [closeTerminal, terminal]
  );

  // const handlePopout: MouseEventHandler<HTMLButtonElement> = useCallback(
  //   e => {
  //     e.stopPropagation();
  //     popTerminalOut(terminal.terminalId);
  //   },
  //   [popTerminalOut, terminal]
  // );
  const selectTab = useCallback(() => {
    setTerminalTabIndex(panelIndex);
  }, [panelIndex, setTerminalTabIndex]);

  return (
    <Tab as={Box} cursor="pointer" onClick={selectTab}>
      <Text noOfLines={1}>{terminal.container}</Text>
      <ButtonGroup ml={2} size="tiny" spacing={1} variant="grayGhost">
        {/* <IconButton
          isRound
          aria-label="popout-terminal"
          icon={<NewWindowIcon />}
          title="Popout Terminal"
          onClick={handlePopout}
        /> */}
        <IconButton
          isRound
          aria-label="close-terminal"
          icon={<CloseIcon />}
          title="Close Terminal"
          onClick={handleCloseTab}
        />
      </ButtonGroup>
    </Tab>
  );
}

export default TerminalTab;
